import React, { useEffect, useState } from "react";
import Header from "../separate/Header1";
import Footer from "../separate/Footer1";
import { NavLink , Link} from "react-router-dom";
import{getCmsContent} from "../actions/axioss/cms.axios";


import leftcurve from '../assets/images/joyimg/leftcurve.png';
import rightcurve from '../assets/images/joyimg/rightcurve.png';

export default function PrivacyPolicy(){

const [privacyPolicy,SetprivacyPolicy]=useState([])
   useEffect(()=>
   {
    privacypolicy();
   },[])
    const privacypolicy =async()=>{
   
        var resp = await getCmsContent("privacypolicy");
        // console.log("cmslist",resp.data)
        if(resp?.status)
        SetprivacyPolicy(resp.data);
    }
    return(
        <>
         <div className="inheader">
            <Header />
                <div className="privacy_policy">
                <img src={leftcurve} className="leftcurve" alt="golds" />
                        <img src={rightcurve} className="rightcurve" alt="golds" />
                        <div className="jill">
                <div className="tf-container">
                <div className="row">
                    <section className="tf-page-title">
                        <div className="col-md-12">
                            {/* <ul className="breadcrumbs" data-aos="fade-right">
                                <li><NavLink to="/">Home</NavLink></li>
                                <li>Privacy Policy</li>
                            </ul> */}
                            {/* <h4 className="page-title-heading" data-aos="fade-left">
                                Privacy Policy
                            </h4> */}
                             <h2 className="headingzz pb-5"> Terms <span style={{ color: 'black' }}>of Services </span></h2>
                            </div>
                        </section>
                    </div>
                    <div className="tf-add-nft" data-aos="fade-right">
                   
                        <div className="content">
                            {/* <div dangerouslySetInnerHTML={{ __html: privacyPolicy?.answer }}></div> */}
                            <p className="mission-p mt-1">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                            <br></br><br></br>
                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", 
                            <br></br><br></br>
                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", 
                            </p>
                        </div>
                    </div>
                </div>
                </div>
                </div>
                
            <Footer />
            </div>
        </>
    )
}